// src/main.jsx
// Must stay the first import: it takes the host's name off /invite/ links
// before analytics or Sentry can read the URL, and forwards them to the
// website's invite (see lib/inviteScrub.js).
import './lib/inviteScrub';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';
import { initSentry } from './utils/sentry';
import { AuthProvider } from './contexts/AuthProvider.jsx';
import { captureInboundAttribution } from './utils/inboundAttribution';
import { captureClaimHandoff } from '@tasted/utils/claimHandoff';
import { registerApp } from '@tasted/utils/analytics';
import { startPageVisibilityTracking } from './lib/pageVisibility';

// Every Mixpanel event from this app says app: 'game'.
registerApp('game');
// TAS-466: "Page Hidden" / "Page Visible", so we can see when phones go down.
startPageVisibilityTracking();

// Initialize Sentry before rendering
initSentry();

// Before the router mounts (TAS-371). A tokenised link lands on
// /join/CODE?t=… and is redirected to /onboarding within a tick — read it any
// later and there is nothing left to read.
captureInboundAttribution();
// TAS-373: analytics-logger already lifted any /welcome claim handoff off the
// URL at import; this repeats it (idempotently) before BrowserRouter reads the
// location, so Router's location.search never holds `ct` either.
captureClaimHandoff();

createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
